<div class="row" style="margin-bottom: 15px;">

  <div class="col-lg-12">
      <div class="col-lg-3">
        <select [(ngModel)]="regionFilter" (change)="applyFilter()" class="form-control">
          <option value=""> Select Region </option>
          <option *ngFor="let regionRow of regionList"  value="{{regionRow.region_name}}"> {{regionRow.region_name}} </option>
        </select>
      </div>

      <div class="col-lg-3">
        <select [(ngModel)]="districtFilter" (change)="applyFilter()" class="form-control">
          <option value=""> Select District </option>
          <option *ngFor="let district of districtList"  value="{{district.city}}"> {{district.city}} </option>
        </select>
      </div>
  </div>
  <div class="col-lg-12" style="margin-top: 1%; ">

    <div class="col-md-4" style="cursor: pointer;" title="Click to see report" (click)="switchReportList('closeReport')">
      <div class="panel has-bg-image" style="color: #fff; background-color: #0091F2; border-radius: 5px;">
        <span class="col-lg-12" style="font-size: 18px; font-weight: 500;">Monitoring report of device close status</span>
        <div class="text-center panel-body">
          <span *ngIf="!countLoader" style="font-size: 50px;" class="text-semibold no-margin-bottom mt-5">{{reportCardCount.closeIndustry}}</span>
          <span *ngIf="countLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></span>
          <div class="content-group" style="font-size: 20px; color: #fff; font-weight: 900;">Reports</div>
        </div>
      </div>
    </div>

    <div class="col-md-4" style="cursor: pointer;" title="Click to see report" (click)="switchReportList('smsReport')">
      <div class="panel has-bg-image" style="color: #fff; background-color: #7F4DC0; border-radius: 5px;">
        <span class="col-lg-12" style="font-size: 18px; font-weight: 500;">Monitoring report of device alert (SMS) status</span>
        <div class="text-center panel-body">
          <span *ngIf="!countLoader"style="font-size: 50px;" class="text-semibold no-margin-bottom mt-5">{{reportCardCount.smsAlert}}</span>
          <span *ngIf="countLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></span>
          <div class="content-group" style="font-size: 20px; color: #fff; font-weight: 900;">Reports</div>
        </div>
      </div>
    </div>

    <div class="col-md-4" style="cursor: pointer;" title="Click to see report" (click)="switchReportList('exceedanceReport')">
      <div class="panel has-bg-image" style="color: #fff; background-color: #909090; border-radius: 5px;">
        <span class="col-lg-12" style="font-size: 18px; font-weight: 500;">Monitoring report of device exceedance status</span>
        <div class="text-center panel-body">
          <span *ngIf="!countLoader" style="font-size: 50px;" class="text-semibold no-margin-bottom mt-5">{{reportCardCount.exceedance}}</span>
          <span *ngIf="countLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></span>
          <div class="content-group" style="font-size: 20px; color: #fff; font-weight: 900;">Reports</div>
        </div>
      </div>
    </div>

  </div>

</div>

  <div *ngIf="activeReport == 'closeReport'">

    <div *ngIf="firstLevel" class="panel panel-flat">
      <div class="panel-heading">
        <h5 class="panel-title">
          <span>Monitoring Report of Device Close Status</span>
          <!--<span style="margin-left: 30px; font-weight: 500; font-size: 10px;" class="text-muted">20/06/2018 - 17-07-2018</span>-->
        </h5>

        <div class="heading-elements">
          <ul class="icons-list">
            <!--<li><i class="icon-file-pdf"></i></li>-->
            <!--<li><i class="icon-file-excel"></i></li>-->
            <!--<li><a data-action="close"></a></li>-->
          </ul>
        </div>

      </div>
      <div class="table-responsive">
      <table *ngIf="!regionLoader" class="table datatable-show-all">
        <thead>
        <tr>
          <th *ngIf="state == 'Delhi'">S. No.</th>
          <th>Region Name</th>
          <th>Name of Officer</th>
          <th>District</th>
          <th style="text-align: center;">Total No of Industries</th>
          <th style="text-align: center;">No of Industries Offline</th>
        </tr>
        </thead>

        <tbody *ngFor="let regionDetail of firstLevel | keyvalue let i = index" [attr.data-index]="i">
        <tr *ngFor="let region of regionDetail.value | keyvalue">
          <!--<tr>-->
          <th *ngIf="state == 'Delhi'">{{i+1}}</th>
          <td>{{region.key}}</td>
          <td>{{region.value.name}}</td>
          <td>{{region.value.city}}</td>
          <td style="text-align: center;">{{region.value.industry_count}}</td>
          <td style="text-align: center;">
            <a *ngIf="region.value.total_close" (click)="getCloseIndustryList(region.key,region.value.name)" data-toggle="modal" data-target="#secondLevel">{{region.value.total_close}}</a>
            <a style="color: black; cursor: not-allowed;" *ngIf="!region.value.total_close">{{region.value.total_close}}</a>
          </td>
        </tr>
        </tbody>
      </table>
      </div>

      <div *ngIf="regionLoader">
        <div colspan="12" class="col-lg-12 text-center" style="height: 180px;">
          <div style="margin-top: 50px;">
            <img src="/assets/images/load.gif" />
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!firstLevel"  class="col-lg-12 text-center" style="height: 180px;">
      <div style="font-size: 28px; font-weight: 600; color: red; margin-top: 50px;">
        No Close Industry Report Found
      </div>
    </div>

    <div id="secondLevel" class="modal fade" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title" *ngIf="!moreDetailDrilled">{{selectedOfficerName}} | {{selectedRegionName}}</h4>
            <h4 class="modal-title" *ngIf="moreDetailDrilled">{{selectedIndustryName}} | {{selectedIndustryAddress}}</h4>
          </div>
          <div class="modal-body">
            <div *ngIf="!moreDetailDrilled" class="table-responsive">
              <table class="table datatable-show-all">
                <thead>
                <tr>
                  <th *ngIf="state == 'Delhi'">S. No.</th>
                  <th>Name of Industry</th>
                  <th>Address of Industry</th>
                  <th>District</th>
                  <th>Average Close Time</th>
                  <th>No of Interval of Close/Non-Operation CEMS</th>
                  <th>Name of Parameter Displayed by Industry</th>
                  <th>Detail Status</th>
                </tr>
                </thead>

                <tbody *ngIf="!industryLoader">
                <tr *ngFor="let industry of closeIndustryList | keyvalue let i = index" [attr.data-index]="i">
                  <th *ngIf="state == 'Delhi'">{{i+1}}</th>
                  <td>{{industry.value.name}}</td>
                  <td>{{industry.value.address}}</td>
                  <td>{{industry.value.city}}</td>
                  <td><span class="label label-danger">{{industry.value.average_time}} Hours</span></td>
                  <td><span class="label label-danger">{{industry.value.total_interval}} Times</span></td>
                  <td>
                    {{industryParameterList[industry.key]['parameter']}}
                  </td>
                  <td>
                    <button (click)="getIndustryCloseTimeWise(industry.value.name,industry.value.address,industry.value.id)" class="btn btn-xs btn-primary"><i class="icon icon-more2"></i> </button>
                  </td>
                </tr>
                </tbody>

                <tbody *ngIf="industryLoader" >
                <tr>
                  <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                    <div style="margin-top: 50px;">
                      <img src="/assets/images/load.gif" />
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div *ngIf="moreDetailDrilled">
              <button (click)="backToPreviousLevel()" class="btn btn-xs btn-primary"><strong><i class="icon icon-arrow-left5"></i>Back</strong> </button>
              <div class="table-responsive">
              <table class="table datatable-show-all">
                <thead>
                <tr>
                  <th style="text-align: center;">SNo.</th>
                  <th style="text-align: center;">Close From</th>
                  <th style="text-align: center;">Close Till</th>
                </tr>
                </thead>
                <tbody *ngIf="!historyLoader">
                <tr *ngFor="let history of closeIndustryHistory | keyvalue let i = index" [attr.data-index]="i">
                  <td style="text-align: center;">{{i + 1}}</td>
                  <td style="text-align: center;">
                    <span class="label label-danger">{{history.value.from_date_time | date: 'dd/MM/yyyy HH:mm'}}</span>
                  </td>
                  <td style="text-align: center;">
                    <span class="label label-danger" *ngIf="history.value.to_date_time"> {{history.value.to_date_time | date: 'dd/MM/yyyy HH:mm'}}</span>
                    <span class="label label-danger" *ngIf="!history.value.to_date_time"> Till Now</span>
                  </td>
                </tr>
                </tbody>
                <tbody *ngIf="historyLoader" >
                <tr>
                  <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                    <div style="margin-top: 50px;">
                      <img src="/assets/images/load.gif" />
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

<!--<app-close-report-list [selectedRegion]="regionFilter" [selectedDistrict]="districtFilter" *ngIf="activeReport == 'closeReport'" ></app-close-report-list>-->
<app-sms-report-list *ngIf="activeReport == 'smsReport'" ></app-sms-report-list>

<div *ngIf="activeReport == 'exceedanceReport'">

  <div *ngIf="firstLevelExceedance" class="panel panel-flat">
    <div class="panel-heading">
      <h5 class="panel-title">
        <span>Monitoring Report of Device Exceedance Status</span>
        <!--<span style="margin-left: 30px; font-weight: 500; font-size: 10px;" class="text-muted">20/06/2018 - 17-07-2018</span>-->
      </h5>

      <div class="heading-elements">
        <ul class="icons-list">
          <!--<li><i class="icon-file-pdf"></i></li>-->
          <!--<li><i class="icon-file-excel"></i></li>-->
          <!--<li><a data-action="close"></a></li>-->
        </ul>
      </div>

    </div>
    <div class="table-responsive">
    <table *ngIf="!regionLoaderExceedance" class="table datatable-show-all">
      <thead>
      <tr>
        <th *ngIf="state == 'Delhi'">S No.</th>
        <th>Region Name</th>
        <th>Name of Officer</th>
        <th>District</th>
        <th style="text-align: center;">Total No of Industries</th>
        <th style="text-align: center;">No of Industries Exceeded Parameter</th>
      </tr>
      </thead>

      <tbody *ngFor="let regionDetail of firstLevelExceedance | keyvalue  let i = index" [attr.data-index]="i">
      <tr *ngFor="let region of regionDetail.value | keyvalue">
        <!--<tr>-->
        <th *ngIf="state == 'Delhi'">{{i+1}}</th>
        <td>{{region.key}}</td>
        <td>{{region.value.name}}</td>
        <td>{{region.value.city}}</td>
        <td style="text-align: center;">{{region.value.industry_count}}</td>
        <td style="text-align: center;">
          <a *ngIf="region.value.exceedance_count" (click)="getExceedanceIndustryList(region.key,region.value.name)" data-toggle="modal" data-target="#secondLevelExceedance">{{region.value.exceedance_count}}</a>
          <a style="color: black; cursor: not-allowed;" *ngIf="!region.value.exceedance_count">{{region.value.exceedance_count}}</a>
        </td>
      </tr>
      </tbody>
    </table>
      </div>
    <div *ngIf="regionLoaderExceedance">
      <div colspan="12" class="col-lg-12 text-center" style="height: 180px;">
        <div style="margin-top: 50px;">
          <img src="/assets/images/load.gif" />
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!firstLevelExceedance"  class="col-lg-12 text-center" style="height: 180px;">
    <div style="font-size: 28px; font-weight: 600; color: red; margin-top: 50px;">
      No Exceedance Industry Report Found
    </div>
  </div>

  <div id="secondLevelExceedance" class="modal fade" role="dialog">
    <div class="modal-dialog">

      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title" *ngIf="!moreDetailDrilledExceedance">{{selectedOfficerNameExceedance}} | {{selectedRegionNameExceedance}}</h4>
          <h4 class="modal-title" *ngIf="moreDetailDrilledExceedance">{{selectedIndustryNameExceedance}} | {{selectedIndustryAddressExceedance}}</h4>
        </div>
        <div class="modal-body">
          <div *ngIf="!moreDetailDrilledExceedance">
            <div class="table-responsive">
            <table class="table datatable-show-all">
              <thead>
              <tr>
                <th *ngIf="state == 'Delhi'">S No.</th>
                <th>Name of Industry</th>
                <th>Address of Industry</th>
                <th>District</th>
                <th>Name of Parameter Exceeded</th>
                <th>Average Exceedance Parameter</th>
                <th>Details of Exceedance</th>
              </tr>
              </thead>

              <tbody *ngIf="!industryLoaderExceedance">
              <tr *ngFor="let industry of exceedanceIndustryList | keyvalue let i = index" [attr.data-index]="i">
                <th *ngIf="state == 'Delhi'">{{i+1}}</th>
                <td>{{industry.value.name}}</td>
                <td>{{industry.value.address}}</td>
                <td>{{industry.value.city}}</td>
                <td>{{industry.value.all_parameter}}</td>
                <td><span class="label label-danger"><strong>{{industryParameterCount[industry.value.id]['percentage']}} %</strong></span></td>
                <td>
                  <button (click)="getIndustryExceedanceHistory(industry.value.name,industry.value.address,industry.value.id)" class="btn btn-xs btn-primary"><i class="icon icon-more2"></i> </button>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="industryLoaderExceedance" >
              <tr>
                <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                  <div style="margin-top: 50px;">
                    <img src="/assets/images/load.gif" />
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
              </div>
          </div>

          <div *ngIf="moreDetailDrilledExceedance">
            <button (click)="backToPreviousLevelExceedance()" class="btn btn-xs btn-primary"><strong><i class="icon icon-arrow-left5"></i>Back</strong> </button>
            <div class="table-responsive">
            <table class="table datatable-show-all">
              <thead>
              <tr>
                <th *ngIf="state == 'Delhi'">S No.</th>
                <th style="text-align: center;">Exceedance Date & Time.</th>
                <th style="text-align: center;">Parameter Exceedance Name</th>
                <th style="text-align: center;">Exceedance Value of Parameter</th>
                <th style="text-align: center;">Prescribed Limit of Parameter</th>
              </tr>
              </thead>
              <tbody *ngIf="!historyLoaderExceedance">
              <tr *ngFor="let history of exceedanceIndustryHistory | keyvalue let i = index" [attr.data-index]="i">
                <th *ngIf="state == 'Delhi'">{{i+1}}</th>
                <td style="text-align: center;">{{history.value.excedance_date  | date: 'dd/MM/yyyy HH:mm'}}</td>
                <td style="text-align: center;">
                  <span class="label label-danger"><strong>{{history.value.name}}</strong></span>
                </td>
                <td style="text-align: center;">
                  <span class="label label-danger"><strong>{{history.value.value}}</strong></span>
                </td>
                <td style="text-align: center;">
                  {{history.value.max}}
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="historyLoaderExceedance" >
              <tr>
                <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                  <div style="margin-top: 50px;">
                    <img src="/assets/images/load.gif" />
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
              </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>


